<template>
    <div class="relative">
        <div class="mb-3 flex justify-end">
            <vs-button
                color="success"
                type="flat"
                size="small"
                @click="copy"
                :disabled="!str.length || !notification"
            >{{$t('tooltip.Copy')}}</vs-button>
        </div>
        <highlight-code lang="json">{{str}}</highlight-code>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler";
import {object} from '@/utils/mixins'
import {copy} from '@/utils/utils'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [object],

    data() {
        return {
            str: '',
            notification: true,
        }
    },

    methods: {
        copy() {
            copy(this.str)

            if (this.notification) {
                this.$vs.notify({
                    title: 'Success!',
                    text: this.$t('notification.success'),
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })

                this.notification = false
            }
        },

        json(data) {
            try {
                return JSON.parse(data)
            } catch (e) {
                return data
            }
        },

        parseData(data) {
            try {
                const a = this.json(data)

                if (typeof a === 'string' || typeof a === 'number') {
                    return a
                } else if (this.isObject(a) || Array.isArray(a)) {
                    return JSON.stringify(a, null, 4)
                } else {
                    return a
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    mounted() {
        this.str = this.parseData(this.popupData)

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
